import ComicCard from '@/components/feature/ComicCard';
import type { Comic } from '@/mocks/comics';

interface HotComicsProps {
  comics: Comic[];
}

export default function HotComics({ comics }: HotComicsProps) {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              大家都在看的人气漫画
            </p>
          </div>
          <div className="flex items-center gap-2">
            <span className="w-8 h-0.5 bg-accent-500 rounded-full"></span>
            <span className="w-4 h-0.5 bg-accent-300 rounded-full"></span>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {comics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}